import { HttpEvent, HttpRequest, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { AuthService } from '../../features/auth/auth.service';
import { config } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);

  const loginUrl = `${config.endPointURL}User/Login`;

  if (req.url === loginUrl) {
    return next(req);
  }

  const token = authService.getToken();

  let modifiedRequest = req;

  if (token) {
    modifiedRequest = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  return next(modifiedRequest).pipe(
    catchError((error) => {
      if (error.status === 401) {
        authService.handleSessionExpiry();
        return EMPTY;
      }
      return throwError(() => error);
    })
  );
};
